import { DetailedHTMLProps, FC, InputHTMLAttributes, ReactNode } from "react";
import { InputBaseProps, InputContainer } from ".";
import classNames from "classnames";

interface props extends InputBaseProps {
  ltr?: boolean;
  borderless?: boolean;
  endComponent?: ReactNode;
  startComponent?: ReactNode;
  inputProps?: DetailedHTMLProps<
    InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >;
}

export const TextInput: FC<props> = (props) => {
  return (
    <InputContainer {...props}>
      <div
        className={classNames(
          "flex items-center rounded-[10px] h-[42px] border overflow-hidden",
          {
            "border-none": props.borderless,
            "border-error bg-error-light": props.hasError,
            "border-gray-300 bg-white": !props.hasError,
          }
        )}
      >
        {!!props.startComponent && (
          <div className="max-h-full">{props.startComponent}</div>
        )}
        <input
          {...props.inputProps}
          dir={props.ltr ? "ltr" : "rtl"}
          className="flex-1 bg-transparent text-sm px-2 outline-none w-0"
        />
        {!!props.endComponent && (
          <div className="max-h-full">{props.endComponent}</div>
        )}
      </div>
    </InputContainer>
  );
};
